import React from 'react';

const NAV_ITEMS = [
    { key: 'compose', label: 'Compose', icon: 'bi-pencil-square' },
    { key: 'templates', label: 'Templates', icon: 'bi-file-earmark-richtext' },
    { key: 'drafts', label: 'Drafts', icon: 'bi-file-earmark' },
    { key: 'scheduled', label: 'Scheduled Emails', icon: 'bi-clock-history' },
    { key: 'sent', label: 'Sent Emails', icon: 'bi-send-check' },
    { key: 'failed', label: 'Failed Deliveries', icon: 'bi-exclamation-triangle' },
    { key: 'history', label: 'Email History', icon: 'bi-clock' },
    { key: 'analytics', label: 'Analytics', icon: 'bi-bar-chart' },
    { key: 'audit', label: 'Audit Log', icon: 'bi-shield-check' },
];

const EmailCenterNav = ({ activeSection, onNavigate }) => (
    <nav className="email-center-nav" aria-label="Email Center sections">
        <ul className="list-unstyled mb-0">
            {NAV_ITEMS.map((item) => (
                <li key={item.key}>
                    <button
                        type="button"
                        className={`email-center-nav-link ${activeSection === item.key ? 'active' : ''}`}
                        onClick={() => onNavigate(item.key)}
                        aria-current={activeSection === item.key ? 'page' : undefined}
                    >
                        <i className={`bi ${item.icon} me-2`}></i>
                        {item.label}
                    </button>
                </li>
            ))}
        </ul>
    </nav>
);

export default EmailCenterNav;
